var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogleCalender(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35 13H13V35H35V13Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.6797 20.92L26.6877 22.36L28.2717 21.208V29.56H29.9997V18.616H28.5597L25.6797 20.92Z",
    fill: "#1E88E5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.943 23.745C23.568 23.171 23.956 22.375 23.956 21.496C23.956 19.749 22.423 18.328 20.539 18.328C18.937 18.328 17.567 19.337 17.209 20.781L18.866 21.202C19.031 20.538 19.734 20.056 20.539 20.056C21.481 20.056 22.248 20.702 22.248 21.496C22.248 22.29 21.481 22.936 20.539 22.936H19.542V24.664H20.539C21.62 24.664 22.532 25.415 22.532 26.304C22.532 27.208 21.666 27.944 20.601 27.944C19.639 27.944 18.817 27.334 18.687 26.526L17 26.802C17.262 28.438 18.81 29.672 20.6 29.672C22.607 29.672 24.24 28.161 24.24 26.304C24.24 25.281 23.736 24.363 22.943 23.745Z",
    fill: "#1E88E5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M34 42H14L13 38L14 34H34L35 38L34 42Z",
    fill: "#FBC02D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M38 35L42 34V14L38 13L34 14V34L38 35Z",
    fill: "#4CAF50"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M34 14L35 10L34 6H9C7.343 6 6 7.343 6 9V34L10 35L14 34V14H34Z",
    fill: "#1E88E5"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M34 34V42L42 34H34Z",
    fill: "#E53935"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M39 6H34V14H42V9C42 7.343 40.657 6 39 6Z",
    fill: "#1565C0"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M9 42H14V34H6V39C6 40.657 7.343 42 9 42Z",
    fill: "#1565C0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleCalender);
export default __webpack_public_path__ + "static/media/google_calender.90cdfa567e864a13cadc7ba883b9ece5.svg";
export { ForwardRef as ReactComponent };